import * as React from 'react'
import { Context } from './provider'

export function usePreloadConfig(keys: string[]) {
	const client = React.useContext(Context)

	if (client === null) {
		throw new Error('No ConfigClient set, use ConfigProvider to set one')
	}

	client.preload(keys)
}
